
// Odeslani vyhledavaciho formulare. Lze odeslat 2 tlacitky, budto jako "Obsah", nebo jako "Kontakty"


Drupal.behaviors.popupSearch = {
  attach(context) {

    // kontrola aby se dialog zavolal pouze jednou - 1. podminka je pro prihlasene, 2. pro neprihlasene
    if (context !== $('dialog.dialog_search').get(0) && context !== document) {
      return;
    }

    const popupSearch = new window.upceModal('search');

    if (popupSearch.status()) {

      // otevreni dialogu pomoci alt+f | option+f
      // lze i varianta s windows+f | cmd+f - tedy prepsani defaultniho chovani prohlizece
      document.addEventListener("keydown", function(e) {
        if (e.code == 'KeyF' && e.altKey) {
        // if (e.code == 'KeyF' && e.metaKey) {
          e.preventDefault();
          popupSearch.openDialog(e);
        }
      });

      // focus pri otevreni popupu
      popupSearch.dialog.addEventListener("open", function(e) {
        const search_field = document.getElementById('search-field');
        search_field.focus();
      });

      popupSearch.dialog.addEventListener("close", function(e) {
        // console.log("close");
      });

      const search_form = document.getElementById('search-form');
      const search_field = document.getElementById('search-field');

      const submit_obsah_button = document.getElementById('search_content');
      const submit_contacts_button = document.getElementById('search_contacts');

      submit_obsah_button.addEventListener("click", function() {
        if (submit_obsah_button.dataset.domain) {
          search_form.action = (submit_obsah_button.dataset.lang == 'en' ? '/en' : '') + '/search' + (submit_obsah_button.dataset.domain == 'www_upce_cz' ? '' : '/domain');
          search_field.name = 'keys';          
        } else {
          search_form.action = '/search/node';
          search_field.name = 'keys';
        }
      });

      if (submit_contacts_button) {      
        submit_contacts_button.addEventListener("click", function() {
          search_form.action = (submit_contacts_button.dataset.lang == 'en' ? '/en' : '') + '/people';
          search_field.name = 'combine';      
        });
      }

    }
  }
};
